
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import ChipMixin from "@/components/shared/chips/ChipMixin";
import {Location} from "vue-router";

@Component({
  mixins: [ChipMixin],
})
export default class UserChip extends ChipMixin {
  @Prop()
  protected item!: any;

  protected toUrl(): Location|null {
    return this.itemId ? {name: 'user', params: { userId: `${ this.itemId }`, }} : null;
    // return this.itemId ? UrlHelper.mayorUser(this.itemId) : null;
  }

  protected get itemName(): string {
    if (this.name) {
      return this.name;
    } else if (this.item.first_name || this.item.last_name) {
      return `${this.item.first_name} ${this.item.last_name}`;
    } else if (this.item.email) {
      return this.item.email;
    } else if (this.item.phone_number) {
      return this.item.phone_number;
    } else {
      return "???";
    }
  }

  protected get caption(): string | null {
    return null;
  }

  protected get getTitle(): string | null {
    if (
      !this.title &&
      this.item &&
      this.item.email
    ) {
      return this.item.email;
    }
    if (
      !this.title &&
      this.item &&
      (this.item.first_name || this.item.last_name)
    ) {
      return this.item.first_name + " " + this.item.last_name;
    }
    return this.title || null;
  }

  protected onClick(): void {
    /**
     * Click event
     *
     * @event click
     */
    this.$emit('click')
  }
}
